import {
    afterRenderEffect,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    inject,
    input,
    output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import type { ResolvedProblemDetails } from '@quipex/core/utils';
import { ErrorState, LoadingState, QpxButton } from '@quipex/shared/ui';

@Component({
    selector: 'qpx-building-access-check',
    imports: [MatButtonModule, ErrorState, LoadingState, QpxButton],
    templateUrl: './building-access-check.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'p-main flex h-full items-center justify-center outline-none',
        role: 'region',
        tabindex: '-1',
        'aria-label': 'Building access',
    },
})
export class BuildingAccessCheck {
    private readonly element =
        inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
    protected readonly error: ResolvedProblemDetails = {
        title: 'We couldn’t check your access',
        status: 503,
        detail: 'Your changes are still here. Retry to continue editing.',
    };
    public readonly checking = input(true);
    public readonly retryRequested = output<void>();

    constructor() {
        afterRenderEffect(() => {
            const checking = this.checking();
            queueMicrotask(() => {
                if (
                    this.element.isConnected &&
                    checking === this.checking() &&
                    !document.querySelector('[role="dialog"]')
                )
                    this.element.focus();
            });
        });
    }
}
